module.exports = __webpack_public_path__ + "img/contact-white-avatar.fb9d01f4.svg";